import { Collection } from '../../interfaces';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isEligible = (collection: Collection): boolean => false;
